module.exports = __webpack_public_path__ + "img/20190627162120376.b278c98d.png";